import { connect } from 'react-redux'
import { setSearchFilter } from '../roles-actions'
import { filterViewData, createCopy } from '../roles-utils'
import { generateGrouping } from '../../utils/utilities'
import ListViewTreeContainer from '../../reusables/containers/list-view-tree-container'
import Enums from '../../utils/enums'

const mapStateToProps = (state) => {
  if (!state[state.core.tabObject.activeApp]) {
    return {}
  }

  if (state.core.tabObject.activeApp !== Enums.APP_IDS.ROLES) {
    return {}
  }

  const appId = state.core.tabObject.activeApp
  const data = state[appId].data
  const viewData = filterViewData(data, state[appId].searchFilter)
  const isActiveDescriptionFilter = generateGrouping(viewData, 'isActiveDescription')

  return {
    viewData,
    isActiveDescriptionFilter
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onCreateCopy: (recordData, callback) => {
      createCopy(recordData, callback)
    },
    setSearchFilter: (value) => {
      dispatch(setSearchFilter(value))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ListViewTreeContainer)
